import { create } from "zustand";

const initialPhases = () => ["pending", "pending", "pending"];

export const useWebsiteAnalysisToastStore = create((set) => ({
  brandLabel: "",
  hostScan: "",
  headerSubtitle: "Scanning your website...",
  phases: initialPhases(),
  progress: 0,
  isDone: false,
  isError: false,
  errorMessage: "",

  setPatch: (patch) => set((s) => ({ ...s, ...patch })),

  reset: () =>
    set({
      brandLabel: "",
      hostScan: "",
      headerSubtitle: "Scanning your website...",
      phases: initialPhases(),
      progress: 0,
      isDone: false,
      isError: false,
      errorMessage: "",
    }),
}));
